import { useOutletContext } from "react-router-dom";
import type { DetalheDoSistema } from "@/api/contrato";

/**
 * A aplicação do caminho, para qualquer aba abaixo de `/aplicacoes/:id`.
 *
 * Vem do `Outlet` da página, que só monta as abas com o detalhe em mãos: aba nenhuma
 * precisa de esqueleto próprio nem de uma segunda consulta, e o `404` é da página.
 */
export function useAplicacaoDaRota(): DetalheDoSistema {
  return useOutletContext<DetalheDoSistema>();
}
